/*
Copied from common-ui/payments. At some point, this will be moved into it's own module exported
from common-ui, but until that day we are putting it here.

This will need to be run in a created block before any component map functions.
Ideally in a wrapper component. Otherwise `mapGetters` may return undefined for some getters.
*/
export default function loadVuexModule({ store, module, moduleName }) {
  if (!(store && store.state && store.state[moduleName])) {
    store.registerModule(
      moduleName,
      module,
    );
  }
}
